import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) =>
  apiCall("get", endpoint, null, { params }).then((r) => r.data);

const post = (endpoint, body) =>
  apiCall("post", endpoint, body).then((r) => r.data);

export const getCountApi                = (params) => get("dashboard/count", params);
export const getVendorAnalysApi         = (params) => get("dashboard/vendor_analytics", params);
export const getPaymentTypeOverApi      = (params) => get("dashboard/paymenttype_based_overview", params);
export const getProjectBasedOverApi     = (params) => get("dashboard/project_based_overview", params);
export const getVendorBasedOverApi      = (params) => get("dashboard/vendor_based_overview", params);
export const getPendingPaymentApi       = (params) => get("dashboard/periodwise_pending_payment", params);
export const getCountryBasedOverviewApi = (params) => get("dashboard/country_based_overview", params);
export const getStateBasedOverviewApi   = (params) => get("dashboard/state_based_overview", params);
export const getVendorDetailsApi        = (params) => get("dashboard/vendor_detailed_overview", params);
export const getProjectStageDetailsApi  = (params) => get("dashboard/project_stage_list", params);
export const getPaymentOverviewApi      = (params) => get("dashboard/payment_overview", params);
export const getAmountAnalysApi         = (params) => get("dashboard/amount_analytics", params);
export const getPoPaymentApi            = (params) => get("dashboard/purchase_order_payment_analytics", params);
export const getPoStatusApi             = (params) => get("dashboard/purchase_order_status_analytics", params);
export const getStageApi                = ()       => get("dashboard/get_project_stages");
export const getVendorApi               = ()       => get("get_vendor");
export const getProductApi              = ()       => get("get_product");
export const getProjectApi              = ()       => get("get_project");
export const getVendorSpendApi          = (body)   => post("dashboard/vendor_spending", body);
export const getProductSpendApi         = (body)   => post("dashboard/product_spending", body);
export const getTransOverViewApi        = (body)   => post("dashboard/transaction_overview", body);
